import React, { useState, useEffect } from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
export const DropdownNavItem = ({ name, link: linkOrFunction, openInNewTab = false, onNavigate = () => { }, }) => {
    const isFunction = typeof linkOrFunction === 'function';
    const target = openInNewTab ? '_blank' : undefined;
    const [link, setLink] = useState(isFunction ? '' : linkOrFunction);
    useEffect(() => {
        const isFunction = typeof linkOrFunction === 'function';
        if (isFunction) {
            setLink(linkOrFunction());
        }
        else {
            setLink(linkOrFunction);
        }
    }, [linkOrFunction]);
    if (link.startsWith('/')) {
        return (React.createElement(NavDropdown.Item, { onClick: () => onNavigate(link) }, name));
    }
    else {
        return (React.createElement(NavDropdown.Item, { target: target, href: link }, name));
    }
};
//# sourceMappingURL=DropdownNavItem.js.map